import { render, staticRenderFns } from "./CmsDisabledBanner.vue?vue&type=template&id=6d8b5ccc&scoped=true&lang=pug&"
import script from "./CmsDisabledBanner.vue?vue&type=script&lang=js&"
export * from "./CmsDisabledBanner.vue?vue&type=script&lang=js&"
import style0 from "./CmsDisabledBanner.vue?vue&type=style&index=0&id=6d8b5ccc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b5ccc",
  null
  
)

/* custom blocks */
import block0 from "./CmsDisabledBanner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports